import { render, staticRenderFns } from "./SidebarAnchors.vue?vue&type=template&id=0807a8d4&scoped=true&"
import script from "./SidebarAnchors.vue?vue&type=script&lang=js&"
export * from "./SidebarAnchors.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAnchors.vue?vue&type=style&index=0&id=0807a8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0807a8d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
